import React, { useState } from "react";
import { MemoSection } from "@design-system/MemoSection/MemoSection";
import { BooleanControl, TextareaControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./DataDisplayPlayground.module.scss";

const defaultMemo =
    "Annual software renewal. Confirm the prepaid expense schedule before closing August.";

export const MemoSectionPlayground = () => {
    const [memo, setMemo] = useState<string | null>(defaultMemo);
    const [hasLabel, setHasLabel] = useState(false);

    const handleUpdateMemo = (nextMemo: string | null) => {
        setMemo(nextMemo);
        return Promise.resolve();
    };

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Content</h2>
                        <TextareaControl
                            label="Memo"
                            value={memo ?? ""}
                            onChange={(value) => setMemo(value || null)}
                            placeholder="Leave empty to show the placeholder"
                        />
                    </section>
                    <section>
                        <h2>Layout</h2>
                        <div className={styles.booleanGrid}>
                            <BooleanControl
                                label="Show metadata label"
                                checked={hasLabel}
                                onChange={setHasLabel}
                            />
                        </div>
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary={memo ? `${memo.length} characters` : "empty"}
                output={JSON.stringify(
                    {
                        memo,
                        label: hasLabel ? "Memo" : null,
                        onUpdateMemo: "local mock update",
                    },
                    null,
                    2,
                )}
            >
                <div className={styles.surface}>
                    <MemoSection
                        memo={memo}
                        onUpdateMemo={handleUpdateMemo}
                        label={hasLabel ? "Memo" : undefined}
                    />
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
